import { AccountTreeRounded, Close, Email } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Modal, Table, TableCell, TableContainer, TableRow, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { IMovimentacaoResumed, IFetchWorkspaceTemplate } from "../../types";
import { MovimentacaoTable } from "./Table";
import { Main } from "./styled";
import { useHistory, useParams } from "react-router-dom";

import { ModalApproval } from "./ModalApproval";
import { ModalStatus } from "./ModalStatus";
import { useState } from "react";
import { useAlert } from "contexts/alert";
import { useAuth } from "contexts/auth";
import api from "services/api";
import ExportSVG from "components/svg/export";

import { ViewMode } from "../../types";

interface IResumedViewProps {
  movimentacao: IMovimentacaoResumed;
  setViewMode: (view: ViewMode) => void;
  template: IFetchWorkspaceTemplate;
}

function formatDate(dateToFormat: string) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();
    
    return dayjs(dateToFormat).format(`DD/MM/YYYY - HH:mm:ss`);
  } catch (error) {
    return `--/--/---- --:--:--`
  }
}

export function ResumedView({ movimentacao, template, setViewMode }: IResumedViewProps) {
  const { workspaceId, templateId } = useParams() as { workspaceId: string, templateId: string };
  const history = useHistory();
  const { openAlert } = useAlert();
  const user = useAuth();
  const status = movimentacao?.status ?? "IDLE";
  const [isExported, setIsExported] = useState(false);
  const [isSendingExport, setIsSendingExport] = useState(false);

  // console.log("OPA", movimentacao.result)
  // console.log(movimentacao.result);

  
  const isBuyer = ["77710728000131", "70204870000168", "70204870000249", "70204870000320", "59291534000167", "47756998000112", "31439951000195", "34499567000176", "00278017000105"].includes(user?.user?.organization?.cnpj ?? "");

  // console.log("ASD", user.user?.organization?.cnpj)

  const [isModalApprovalOpen, setIsModalApprovalOpen] = useState(false);
  const [isModalExportOpen, setIsModalExportOpen] = useState(false);
  const [isModalStatusOpen, setIsModalStatusOpen] = useState(false);

  const [isSendingApproval, setIsSendingApproval] = useState(false);

  async function handleSubmitApproval() {
    try {
      setIsSendingApproval(true);
      const dagRunId = movimentacao.result.find(m => m.dagRunId)?.dagRunId ?? null;
      const approveActivity = template.activities.find(activity => activity.name === "Aprovação");

      await api.post(`/v2/workspaces/${workspaceId}/templates/${templateId}/approval/${approveActivity?.workspaceActivityId}`, {
        tableName: "MASSA_MOVIMENTADA",
        dagRunId: dagRunId,
      });

      openAlert('Aprovação realizada com sucesso', 'success')
    } catch (error) {
      openAlert('Houve algum error na aprovação', 'error')
    } finally {
      setIsSendingApproval(false);
      setIsModalApprovalOpen(false);
    }
  }

  async function handleExport() {
    try {
      setIsSendingExport(true);
      const exportActivity = template.activities.find(activity => activity.name === "Exportação");

      if ((user.user?.organization?.email === 'murilo@conducco.com' && exportActivity?.workspaceActivityId === "a29ffbc8-cacf-4248-8863-2eec502a9914") || (user.user?.organization?.email === 'vida.previdencia@touaregseguros.com' && exportActivity?.workspaceActivityId === "a29ffbc8-cacf-4248-8863-2eec502a9914")) {
        await api.post(`/v2/airflow/export-hapvida/${exportActivity?.workspaceActivityId}`)
      } else {
        await api.post(`/v2/workspaces/${workspaceId}/templates/${templateId}/export/${exportActivity?.workspaceActivityId}`, {
          approvedDate: dayjs().format("DD/MM/YYYY"),
          approvedBy: user?.user?.name ?? "",
          total: movimentacao?.metrics?.total ?? 0,
          admissions: movimentacao?.metrics?.["Inclusão"] ?? 0,
          exclusions: movimentacao?.metrics?.["Demissão"] ?? 0,
          changes: movimentacao?.metrics?.["Alteração"] ?? 0,
          transfers: movimentacao?.metrics?.["Transferência"] ?? 0,
        });
      }

      setIsExported(true);
    } catch (error) {
      openAlert('Houve algum error na exportação', 'error')
    } finally {
      setIsSendingExport(false);
      setIsModalExportOpen(false);
    }
  }

  return (
    <>
      <Modal
        open={isModalExportOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            height: "auto",
            width: "100%",
            maxWidth: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "1rem",
            border: "none",
            outline: "none",
            padding: "24px",
          }}
        >
        <div style={{"display":"flex","justifyContent":"space-between","alignItems":"center"}}>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Exportar arquivo</h6>
          <Close
            style={{"cursor":"pointer"}}
            onClick={() => setIsModalExportOpen(false)}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '34px' }}>
          <span style={{ fontSize: '16px', lineHeight: '150%', fontWeight: '400', color: '#191C1A' }}>Se você verificou e está tudo certo e deseja exportar as movimentações aprovadas pelo cliente clique no botão <strong>"Exportar"</strong>, caso gostaria de verificar novamente clique em <strong>"Verificar novamente"</strong></span>
        </div>

        {/* <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: "24px" }}>
          <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>O arquivo sera enviado para:</p>
          <Tooltip title={user?.user?.email} arrow placement="bottom-start">
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: '#F5F5F7',
              padding: '4px 10px',
              borderRadius: '16px',
              width: 'fit-content',
              cursor: "pointer"
            }}>
              <Email style={{ fontSize: '13px', color: '#4825d3' }} />
              <span style={{ fontSize: '13px', color: '#1D1D1F' }}>E-mail</span>
            </div>
          </Tooltip>
        </div> */}

        <div style={{"display":"flex","paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"1rem","justifyContent":"flex-end","alignItems":"center","width":"100%"}}>
          <div style={{"display":"flex","gap":"0.25rem"}}>
            <Button
              variant='outlined'
              color='error'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={() => setIsModalExportOpen(false)}
              disabled={isSendingExport}
            >
              Verificar novamente
            </Button>

            <Button
              variant='contained'
              style={{ minWidth: "180px", "paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={handleExport}
              disabled={isSendingExport}
            >
              {!isSendingExport ? "Exportar" : <CircularProgress size="20px"/>}
            </Button>
          </div>
        </div>
        </Box>
      </Modal>
      <ModalApproval isOpen={isModalApprovalOpen}>
        <div style={{"display":"flex","justifyContent":"space-between","alignItems":"center"}}>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Gostaria de aprovar as movimentações?</h6>
          <Close
            style={{"cursor":"pointer"}}
            onClick={() => isSendingApproval ? null : setIsModalApprovalOpen(false)}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '34px', marginTop: '24px' }}>
          <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Dados atualizados em</p>
          <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600', color: '#6F6F78' }}>{formatDate(movimentacao.executionDate)}</span>
        </div>

        <div style={{"display":"flex","paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"1rem","justifyContent":"flex-end","alignItems":"center","width":"100%"}}>
          <div style={{"display":"flex","gap":"0.25rem"}}>
            <Button
              variant='outlined'
              color='error'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              disabled={isSendingApproval}
              onClick={() => setIsModalApprovalOpen(false)}
            >
              Não, vou verificar novamente
            </Button>

            <Button
              variant='contained'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              disabled={isSendingApproval}
              onClick={handleSubmitApproval}
            >
              Sim, aprovar
            </Button>
          </div>
        </div>
      </ModalApproval>
      <ModalStatus isOpen={isModalStatusOpen}>
        <div style={{"display":"flex","justifyContent":"space-between","alignItems":"center"}}>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Atividades relacionadas</h6>
          <Close
            style={{"cursor":"pointer"}}
            onClick={() => setIsModalStatusOpen(false)}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '34px', marginTop: '24px' }}>
          <span style={{ fontSize: '16px', lineHeight: '175%', fontWeight: '400', color: '#191C1A' }}>Para ter Exportar Movimentação atualizada verifique se as atividades abaixo estão atualizadas de acordo com sua execução programada.</span>
        </div>
        <TableContainer
          sx={{
            "& .MuiTableCell-root": { background: "#FFFFFF !important" },
          }}
        >
          <Table>
            <TableRow style={{ height: "70px" }}>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Nome
                </span>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Última atualização
                </span>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Execução programada
                </span>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Status
                </span>
              </TableCell>
            </TableRow>
            {template.activities.map((activity) => (
              <TableRow key={activity.id} style={{ height: "70px" }}>
                <TableCell>{activity.name}</TableCell>
                <TableCell>{activity.log?.executedAt ? formatDate(activity.log?.executedAt) : "-"}</TableCell>
                <TableCell>{activity.log?.scheduledAt ? formatDate(activity.log?.scheduledAt) : "-"}</TableCell>
                <TableCell>
                  {activity.log.status === "IDLE" && (
                    <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                      <span>Aguardando</span>
                    </div>
                  )}
                  {activity.log.status === "PENDING" && (
                    <div style={{ color: '#EF6C00', backgroundColor: '#EF6C0014', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                      <span>Pendente</span>
                    </div>
                  )}
                  {activity.log.status === "SUCCESS" && (
                    <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                      <span>Executado</span>
                    </div>
                  )}
                  {activity.log.status === "FAILED" && (
                    <div style={{ color: '#a30000', backgroundColor: '#ff7d7d3b', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                      <span>Falhou</span>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </TableContainer>
      </ModalStatus>
      {!isExported && (
        <Main>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600,marginBottom: '24px'}}>Exportar Movimentações</h1>

            {/** Botoes a direita (grid, table, etc) */}
            <div style={{"display":"flex","gap":"0.5rem", alignItems: "center"}}>
              <Button
                variant="outlined"
                style={{
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  borderRadius: "8px",
                  height: "30px",
                  fontSize: "0.875rem",
                  lineHeight: "1.25rem",
                  fontWeight: 600,
                }}
                onClick={() => setViewMode("RETIFICAR")}
              >
                Retificar
              </Button>
              <Button
                variant="outlined"
                style={{
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  borderRadius: "8px",
                  height: "30px",
                  fontSize: "0.875rem",
                  lineHeight: "1.25rem",
                  fontWeight: 600,
                }}
                onClick={() => setIsModalStatusOpen(true)}
              >
                Atividades relacionadas
              </Button>
            </div>
          </div>

          {/** Interface de Data */}
          <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
              <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Data da última exportação</p>
              <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600', color: '#6F6F78' }}>{formatDate(movimentacao.executionDate)}</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
              <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Status</p>
              {status === "IDLE" && (
                <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span>Aguardando</span>
                </div>
              )}
              {status === "PENDING" && (
                <div style={{ color: '#EF6C00', backgroundColor: '#EF6C0014', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span>Pendente</span>
                </div>
              )}
              {status === "SUCCESS" && (
                <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span>Executado</span>
                </div>
              )}
              {status === "FAILED" && (
                <div style={{ color: '#a30000', backgroundColor: '#ff7d7d3b', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span>Falhou</span>
                </div>
              )}
            </div>
          </div>

            {/** Métricas (Total, Inclusoes, etc) */}
            <div style={{"display":"flex","gap":"1rem"}}>
              {Object.entries(movimentacao.metrics).map(([title, value]) => (
                <>
                  {title === "Demissão" ? (
                    <div style={{ width: '100%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'column', marginBottom: '30px' }}>
                      <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Exclusão</p>
                      <span style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600', color: '#6F6F78' }}>{value}</span>
                    </div>
                  ) : (
                    <div style={{ width: '100%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'column', marginBottom: '30px' }}>
                      <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>{title}</p>
                      <span style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600', color: '#6F6F78' }}>{value}</span>
                    </div>
                  )}
                </>
              ))}
            </div>

            <MovimentacaoTable data={movimentacao.result}/>

            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end',"paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"24px" }}>
              <div style={{display: 'flex',"gap":"0.25rem"}}>              
                <Button
                  variant='contained'
                  style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                  onClick={() => setIsModalExportOpen(true)}
                >
                  Exportar Movimentação
                </Button>
              </div>
            </div>
        </Main>
      )}
      {isExported && (
        <Main>
          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "30px", marginTop: "30px", marginBottom: "30px" }}>
            <ExportSVG />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <h1 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Arquivo exportado com sucesso</h1>
              <p style={{ fontSize: '16px', color: '#6F6F78', margin: "0", padding: "0" }}>O arquivo foi enviado para a para a saída escolhida.</p>
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 50px" }}>
                <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>Exportacão realizada em</p>
                <span style={{ fontSize: '16px', lineHeight: "150%", fontWeight: '600', color: '#6F6F78', margin: "0", padding: "0" }}>{dayjs().format("DD/MM/YYYY")}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 50px" }}>
                <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>Exportado por</p>
                <span style={{ fontSize: '16px', lineHeight: "150%", fontWeight: '600', color: '#6F6F78', margin: "0", padding: "0" }}>{user?.user?.name}</span>
              </div>
              {/* <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 50px" }}>
                <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>Arquivo exportado para</p>
                <Tooltip title={user?.user?.email} arrow placement="bottom">
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    backgroundColor: '#F5F5F7',
                    padding: '4px 10px',
                    borderRadius: '16px',
                    width: 'fit-content',
                    cursor: "pointer"
                  }}>
                    <Email style={{ fontSize: '13px', color: '#4825d3' }} />
                    <span style={{ fontSize: '13px', color: '#1D1D1F' }}>E-mail</span>
                  </div>
                </Tooltip>
              </div> */}
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
              {Object.entries(movimentacao.metrics).map(([title, value]) => (
                <div style={{ width: '138px', height: "84px", border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'column' }}>
                  <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>{title}</p>
                  <span style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600', color: '#6F6F78', margin: "0", padding: "0" }}>{value}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "400px", gap: "16px", marginTop: "25px" }}>
              <Button
                variant='contained'
                style={{"borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","fontWeight":600,width: "100%"}}
                onClick={() => history.push(`/v2/workspaces/${workspaceId}`)}
              >
                Retornar para atividades
              </Button>
              <Button
                variant='outlined'
                style={{"borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","fontWeight":600,width: "100%"}}
                disabled
              >
                Ver histórico de aprovações
              </Button>
            </div>
          </div>
        </Main>
      )}
    </>
  );
}
